<template>
  <div class="center-warp">
    <div class="inner">
      <div class="count-card">
        <div class="count-card-top d-flex-between">
          <div class="count-card-top-title">病例咨询</div>
        </div>
        <div class="count-card-bottom d-flex-between">
          <router-link to="case_consult">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">未读消息</div>
              <div class="count-card-item-num">{{ tData.unreadPatientCount }}</div>
            </div>
          </router-link>

          <router-link to="case_consult">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">咨询病例</div>
              <div class="count-card-item-num">{{ tData.consultPatientCount }}</div>
            </div>
          </router-link>

          <router-link to="consultation_room">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">会诊</div>
              <div class="count-card-item-num">{{ tData.meetingPatientCount }}</div>
            </div>
          </router-link>

          <router-link to="/customer_home/customer_data">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">本月未上传复诊卡病例</div>
              <div class="count-card-item-num">{{ tData.noFzCardPatientCount }}</div>
            </div>
          </router-link>

          <router-link to="/customer_home/customer_data">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">无人受理病例</div>
              <div class="count-card-item-num">{{ tData.unacceptedPatientCount }}</div>
            </div>
          </router-link>

          <router-link to="/customer_home/customer_data">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">新咨询导师未回复病例</div>
              <div class="count-card-item-num">{{ tData.unReplyPatientCount }}</div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="count-card">
        <div class="count-card-top d-flex-between">
          <div class="count-card-top-title">订单管理</div>
        </div>
        <div class="count-card-bottom d-flex-between">
          <router-link to="bill_center">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">本周新增订单</div>
              <div class="count-card-item-num">{{ tData.thisWeekOrderCount }}</div>
            </div>
          </router-link>

          <router-link to="bill_center">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">待确认订单</div>
              <div class="count-card-item-num">{{ tData.pendingConfirmOrderCount }}</div>
            </div>
          </router-link>

          <router-link to="bill_center">
            <div class="count-card-item size3-1">
              <div class="count-card-item-name">待发货订单</div>
              <div class="count-card-item-num">{{ tData.pendingShipmentOrderCount }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getServiceData} from "@/http/home";

export default {
  name: "CustomerHome",
  data() {
    return {
      tData: {},
    };
  },
  created() {
    this.getHomeData();
  },
  methods: {
    getHomeData() {
      getServiceData().then(res => {
        this.tData = res.data
      })
    },
  },
}
</script>

<style scoped>
@import '../../assets/css/sales_home.css';
a {
  text-decoration: none;
}
</style>
